import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	CORRESPONDENCE_ISSUED_CATEGORY_FEATURE_KEY,
	CorrespondenceIssuedCategoryState,
	CorrespondenceIssuedCategoryPartialState,
	correspondenceIssuedCategoryAdapter
} from './issued-category.reducer';

// Lookup the 'CorrespondenceIssuedCategory' feature state managed by NgRx
export const getCorrespondenceIssuedCategoryState = createFeatureSelector<
	CorrespondenceIssuedCategoryPartialState,
	CorrespondenceIssuedCategoryState
>(CORRESPONDENCE_ISSUED_CATEGORY_FEATURE_KEY);

const { selectAll, selectEntities } = correspondenceIssuedCategoryAdapter.getSelectors();

export const getCorrespondenceIssuedCategoryLoaded = createSelector(
	getCorrespondenceIssuedCategoryState,
	(state: CorrespondenceIssuedCategoryState) => state.loaded
);

export const getCorrespondenceIssuedCategoryError = createSelector(
	getCorrespondenceIssuedCategoryState,
	(state: CorrespondenceIssuedCategoryState) => state.error
);

export const loadingCorrespondenceIssuedCategory = createSelector(
	getCorrespondenceIssuedCategoryState,
	(state: CorrespondenceIssuedCategoryState) => state.loaded
);

export const getAllCorrespondenceIssuedCategory = createSelector(
	getCorrespondenceIssuedCategoryState,
	(state: CorrespondenceIssuedCategoryState) => selectAll(state)
);

export const getCorrespondenceIssuedCategoryEntities = createSelector(
	getCorrespondenceIssuedCategoryState,
	(state: CorrespondenceIssuedCategoryState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getCorrespondenceIssuedCategoryState,
	(state: CorrespondenceIssuedCategoryState) => state.selectedCorrespondenceIssuedCategoryId
);

export const getSelected = createSelector(
	getCorrespondenceIssuedCategoryEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
